import { Field as RcField } from 'rc-field-form';
import { FieldProps } from 'rc-field-form/es/Field';
import React from 'react';

import { useFieldController } from './form-utils';

/**
 * Here we want to change the default behaviour of how the validation works in
 * form so I think it is ok just to create a wrapper around original component
 * for the simplicity of use.
 */
export const Field: React.FC<FieldProps> = props => {
  const validationProps = useFieldController();

  return <RcField {...validationProps} {...props} />;
};
